import firebase, { auth, storage } from './firebase';

export const getCurrentUser = () => {
	return new Promise((resolve, reject) => {
		const unsubscribe = auth.onAuthStateChanged((userAuth) => {
			unsubscribe();
			resolve(userAuth);
		}, reject);
	});
};
export const googleProvider = new firebase.auth.GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

export const microsoftProvider = new firebase.auth.OAuthProvider('microsoft.com');

export const signInWithGoogle = () => auth.signInWithPopup(googleProvider);

export const signInWithEmail = async ({ email, password }) => await auth.signInWithEmailAndPassword(email, password);
export const signInWithMicrosoft = () => auth.signInWithPopup(microsoftProvider);
export const linkUserWithMicrosoft = () => auth.currentUser.linkWithPopup(microsoftProvider);

export const signUpWithEmailAndPassword = async ({ email, password }) =>
	await auth.createUserWithEmailAndPassword(email, password);

export const resetPassword = (email) => auth.sendPasswordResetEmail(email);

export const signInWithCustomToken = (token) => auth.signInWithCustomToken(token);

export const signOut = () => auth.signOut();

export const changePassword = async ({ currentPassword, newPassword }) => {
	try {
		const user = auth.currentUser;
		if (!user || !user.email) {
			throw new Error('No user is currently signed in');
		}

		const credential = firebase.auth.EmailAuthProvider.credential(user.email, currentPassword);
		await user.reauthenticateWithCredential(credential);

		await user.updatePassword(newPassword);

		return { success: true, message: 'Password updated successfully' };
	} catch (error) {
		// Handle specific Firebase errors
		let errorMessage = 'Failed to update password';

		if (error.code === 'auth/wrong-password') {
			errorMessage = 'Current password is incorrect';
		} else if (error.code === 'auth/weak-password') {
			errorMessage = 'New password is too weak';
		} else if (error.code === 'auth/requires-recent-login') {
			errorMessage = 'Please sign out and sign in again before changing your password';
		} else if (error.message) {
			errorMessage = error.message;
		}

		return { success: false, message: errorMessage };
	}
};

export const uploadFiles = async (filePath, file) => {
	// Returns true on success, the Error on failure. Never throws: legacy callers ignore the
	// return, but the ones that show a success toast MUST check it — a swallowed failure here is
	// how "Upload successful" got shown for uploads that never left the browser.
	let imageRef = storage.ref().child(filePath);
	return imageRef
		.put(file)
		.then(() => true)
		.catch((e) => e);
};
export const deleteFiles = async (filePath) => {
	let imageRef = storage.ref().child(filePath);
	await imageRef
		.delete()
		.then((success) => success)
		.catch((e) => e);
};

export default auth;
